export default __webpack_public_path__ + "static/epilogue-0e56b204887ca27b9b3f4d9556fbac1f.svg";